import EntryMask from './entryMask';

export default EntryMask;
